<button type="button" [class]="buttonClasses" (click)="handleClick()" [disabled]="loader">
	<ng-content *ngIf="!loader"></ng-content>
	<p-loader-circle *ngIf="loader"></p-loader-circle>
</button>
